export const useOfficeTheme = () => {
    // Always return light mode to avoid Office.js theme API compatibility issues
    return { isDark: false };
};
